import { styled } from "@linaria/react";
import React from "react";
import { themeDefault } from "src/theme";

interface IProps extends React.HTMLAttributes<HTMLLabelElement> {
  checked?: boolean;
  name: string;
  className?: string;
  value:string;
}

function RadioInput({
  children,
  checked = false,
  name,
  className,
  value,
  onChange,
  ...props
}: React.PropsWithChildren<IProps>) {
  return (
    <>
      <Label {...props} htmlFor={name} className={className} onChange={(e:any)=>{ if(props?.onClick)props?.onClick(e)}}>
        <input type="radio" checked={checked} name={name} value={value} onClick={(e: any)=>{ console.info("test"); if(props?.onClick)props?.onClick(e)}} />
        <span className="label">{children}</span>
        <span className="checkmark"></span>
      </Label>
    </>
  );
}

export default RadioInput;

const Label = styled.label`
  display: flex;
  position: relative;
  padding-left: 42px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  user-select: none;
  pointer-events: auto;
  span {
    pointer-events: none;
  }

  input:checked ~ .label{ 
    font-weight: 600;
}

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    border: solid 1px #d8d8d8;
  }

  /* On mouse-over, add a grey background color */
  &:hover input ~ .checkmark {
    background-color: white;
  }

  /* When the radio button is checked, add a blue background */
  & input:checked ~ .checkmark {
    background-color: white;
    border: solid 1px #883e89;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  & input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  & .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #883e89;
  }
`;
